import { SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import { Button, Layout, Table } from 'antd';

import { borderRadiusContainer } from '../../../../ui/style-templates';

export const Subtitle = styled('div')`
  font-family: Roboto,serif;
  font-size: 20px;
  line-height: 19px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
  padding-top: 40px;
`;

export const Row = styled('div')`
  display: flex;
`;

export const MainContainer = styled(Layout)<{ newStyle: boolean }>`
  overflow: hidden;

  ${(props): SerializedStyles|null => props.newStyle ? borderRadiusContainer() : null};
`;

export const BlockShadow = styled('div')`
  box-shadow: 0 0 10px var(--E5E5E766-personal-area-billing);
  width: 100%;
  min-height: 100vh;
`;

export const ContainerContent = styled('div')`
  margin: 0 86px;
  color: var(--000000-personal-area-billing);
  font-family: Roboto,serif;
  font-size: 12px;
  display: flex;
  justify-content: space-between;

  .ant-menu-vertical .ant-menu-item::after, .ant-menu-vertical-left .ant-menu-item::after, .ant-menu-vertical-right .ant-menu-item::after, .ant-menu-inline .ant-menu-item::after {
    border-right: 3px solid var(--00B86D-personal-area-billing-right-border);
  }
`;

export const PageTitle = styled('span')`
  margin-top: 40px;
  margin-bottom: 47px;
  color: var(--000000-personal-area-billing);
  font-family: Roboto,serif;
  font-size: 20px;
  line-height: 23px;
  display: inline-block;
`;

export const Col = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentTabs = styled('div')`
  font-size: 14px;
  line-height: 16px;
  opacity: 0.8
`;

export const ContainerNameCol = styled('div')`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
`;

export const TablePan = styled(Table)`
  background: 'green';
  margin-top: 20px;
  background-color: 'green';
  .ant-table-thead > tr > th {
    padding-bottom: 10px;
    background-color: var(--FFFFFF-personal-area-billing);
  }
  .ant-table-tbody > tr > td {
    border-bottom: 0 solid var(--E8E8E7-personal-area-billing);
  }
  margin-left: -15px;
`;

export const DivModal = styled ('div')`
  display: flex;
  justify-content: space-between;
`;

export const BlockModal = styled('div')`
  padding-bottom: 15px;
`;

export const TextTable = styled('div')`
  font-size: 14px;
  line-height: 16px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const Hr = styled('hr')`
  border: none;
  color: var(--E8E8E7-personal-area-billing);
  background-color: var(--E8E8E7-personal-area-billing);
  height: 1px;
`;

export const ButtonPay = styled(Button)`
  width: 56px;
  height: 25px;
  margin-left: 5px;
`;

export const Container = styled.div`
  margin-left: 68px;
  @media screen and (max-width: 420px) {
    margin-left: 0;
  }
`;

export const TextNameTarif = styled('div')`
  font-size: 14px;
  line-height: 21px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
  margin-top: 11px;
`;

export const ButtonChange = styled(Button)`
  background: var(--FCFCFC-personal-area-billing);
  border: 1px solid var(--E4E4E4-personal-area-billing);
  box-sizing: border-box;
  border-radius: 3px;
  height: 25px;
  margin-left: 20px;
  margin-top: 9px;
`;

export const TextGhostPayment = styled('div')`
  font-size: 20px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
  padding: 35px 0 0 0;
  @media screen and (max-width: 420px) {
    padding: 5px 0 0 0;
  }
`;

export const NamePaymentMethod = styled('div')`
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: var(--000000-personal-area-billing);
  opacity: 0.8;
`;

export const TextEmail = styled('div')`
  line-height: 14px;
  color: var(--000000-personal-area-billing);
  opacity: 0.6;
`;

export const BlockInformationPay = styled('div')`
  width: 150px;
`;

export const PaymentMethodsActionsContainer = styled('div')`
  display: flex;
  margin-left: 20px;
  gap: 8px;
`;
